import { useTracking } from 'react-tracking';
import { format } from 'date-fns';
import { Row, Column } from '@simplywallst/ui-core';
import { cn } from '@simplywallst/ui-core/next';
import { Avatar, StyledLink, MetadataSection, PublishedDate } from './styled';
import ReviewedByList from './ReviewedByList';
import type { Article } from '../hooks/useArticle';

interface Props {
  name: string;
  slug: string | null;
  photoURL: string | null;
  publishDate: string;
  updatedDate: string;
  viewCommentsText: string;
  reviewedBy: Article['reviewedBy'];
  onCommentsClick: (e) => void;
}
const Metadata = ({
  name,
  slug,
  photoURL,
  publishDate,
  updatedDate,
  viewCommentsText,
  reviewedBy,
  onCommentsClick,
}: Props) => {
  const { trackEvent } = useTracking();
  const publishDateFormatted = format(new Date(publishDate), 'MMMM dd, yyyy');
  const updatedDateFormatted =
    updatedDate !== publishDate
      ? format(new Date(updatedDate), 'MMMM dd, yyyy')
      : undefined;
  return (
    <>
      <MetadataSection>
        <Row>
          {photoURL && <Avatar src={photoURL} alt={name} className="mt-1" />}
          <Column fillVoid alignSelf={reviewedBy ? 'auto' : 'center'}>
            <StyledLink
              href={`https://simplywall.st/news/about-simply-wall-st-news/${slug}`}
              target="_blank"
              onClick={() => {
                trackEvent({
                  type: 'track',
                  subject: 'author_metadata',
                  action: 'click',
                  slug: slug,
                });
              }}
            >
              {name}
            </StyledLink>
            {reviewedBy && <ReviewedByList authors={reviewedBy} />}
          </Column>
        </Row>
        <a
          href="#comments"
          onClick={onCommentsClick}
          className={cn(
            'text-sm text-brand-01 underline',
            !reviewedBy && 'place-self-center'
          )}
        >
          {viewCommentsText}
        </a>
      </MetadataSection>
      <Row>
        <PublishedDate>
          {updatedDate ? '' : 'Published'}{' '}
          <time dateTime={publishDate}>{publishDateFormatted}</time>
        </PublishedDate>
        {updatedDate && updatedDateFormatted && (
          <PublishedDate>
            &nbsp;&nbsp;•&nbsp;&nbsp;Updated{' '}
            <time dateTime={updatedDate}>{updatedDateFormatted}</time>
          </PublishedDate>
        )}
      </Row>
    </>
  );
};

export default Metadata;
